export enum GOAL {
  TEACHING_PUPPY = 'teaching_puppy',
  SURVIVING_PUPPY = 'surviving_puppy',
  SOCIALIZING_PUPPY = 'socializing_puppy',
  TEACHING_OBEDIENCE = 'teaching_obedience',
  CORRECTING_BEHAVIOR = 'correcting_behavior',
  GETTING_SHAPE = 'getting_shape',
  RASING_ADOPTED_DOG = 'rasing_adopted_dog',
  PLAYING_WITH_POOCH = 'playing_with_pooch',
  OTHER = 'other',
}

export enum AGE {
  ADULT = 'adult',
  PUPPY = 'puppy',
}

export enum BITING {
  YES = 'yes',
  NO = 'no',
  SOMETIMES = 'sometimes',
}

export enum POTTY_TRAINING {
  A_BIT = 'a_bit',
  NO = 'no',
  YES = 'yes',
}

export enum PERSONALIZED_PLAN {
  SINGLE = 'single',
  MULTIPLE = 'multiple',
}
